import { useState } from "react";
import styled from "styled-components";
import correctArrow from "./SubIcons/correctArrow.svg";
import downArrowInput from "./SubIcons/downArrowInput.svg";

export default function FormInpt(props) {
  const [active, setActive] = useState(null);
  const [click, setClick] = useState(false);
  const [value, setValue] = useState("");
  const passValue = (value) => {
    props.ValueChanged(value);
    setValue(value);
    // setValue(e.currentTarget.dataset.value);
  };

  const options = [
    // {
    //   id: 0,
    //   value: "Vehicle Type",
    // },
    {
      id: 0,
      value: "Car",
    },
    {
      id: 1,
      value: "Pickup Truck",
    },
    {
      id: 2,
      value: "Van",
    },
    {
      id: 3,
      value: "SUV",
    },
    {
      id: 4,
      value: "Truck",
    },
  ];
  return (
    <Wrapper>
      <div className="select">
        <div className="selected" onClick={() => setClick(!click)}>
          <span className="text">
            {active !== null ? value : "Vehicle Type"}
            {/* {active === 0 ||
            active === 1 ||
            active === 2 ||
            active === 3 ||
            active === 4
              ? value
              : "Vehicle Type"} */}
          </span>
          <span className="icon">
            <img src={downArrowInput} alt="doownArrow" />
          </span>
        </div>
        <div className="options" style={{ display: click ? "block" : "none" }}>
          {options.map(({ value, id }) => {
            return (
              <div
                key={id}
                onClick={() => {
                  setActive(id);
                  passValue(value);
                  setClick(false);
                }}
                style={{
                  background: active === id ? "#6300FF" : undefined,
                  color: active === id ? "#fff" : undefined,
                }}
              >
                <li className="value" data-value={value}>
                  {value}
                </li>
                {active === id ? (
                  <span className="icon">
                    <img src={correctArrow} alt="correct" />
                    {/* <GoCheck style={{ color: "red" }} /> */}
                  </span>
                ) : undefined}
              </div>
            );
          })}
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .select {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #596278;
  }
  .selected {
    height: 45px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    column-gap: 50%;
    cursor: pointer;
    background: #ffffff;
    border: 1.5px solid #dbe0eb;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .options {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 46px;
    width: 100%;
    z-index: 62 !important;
    position: absolute;
  }
  .options > div {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    background: #ffffff;
    /* border: 1.5px solid #dbe0eb; */
    box-sizing: border-box;
    border-radius: 4px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */

    color: #596278;
  }
  .options > div:hover {
    background: #6300ff;
    color: #ffffff;
  }
  li.value {
    width: 100%;
    align-items: center;
    text-align: left;
    padding-left: 20px;
  }
  .text {
    position: absolute;
    left: 20px;
  }
  .icon {
    position: absolute;
    right: 20px;
  }

  @media screen and (max-width: 414px) {
  }
`;
